import { useEffect, useState } from 'react';

import { useSideMenuItems } from 'src/features/layout/hooks/useSideMenuItems';

import { getAccessedItemsByKeys } from '../utils/lastAccessedPagesUtils';

export function useLastAccessedPages() {
  const [lastAccessedKeys, setLastAccessedKeys] = useState<React.Key[]>();

  const { items } = useSideMenuItems();

  useEffect(() => {
    const lastAccessKeysLogs = localStorage.getItem('accessLogs');
    lastAccessKeysLogs && setLastAccessedKeys(JSON.parse(lastAccessKeysLogs));
  }, []);

  return lastAccessedKeys && getAccessedItemsByKeys(items, lastAccessedKeys);
}
